// Which template kinds our own panels send. A key set to false hands that kind back to the shared component
// (@gs/gs-integration-component's TemplateMessaging) once it can send it, and nothing local takes the kind any more,
// not even under the host's own-form flag (standard/isLocalFormSupported.js). Delete the kind's folder after that;
// ../README.md has the steps. It lives here, apart from ../registry.js, so the Standard panel's own checks can read it
// without importing the registry.
export const LOCAL_SEND = {
  carousel: true,
  gif: true,
  location: true,
  lto: true,
  voiceCall: true,
};
